import { Routes, Route } from "react-router-dom";
import HomePage from "../pages/hompage/HomePage";
import PrivateRoute from "../components/PrivateRouter";
import HomeAdmin from "../pages/Admin/HomeAdmin";
import Login from "../pages/login/Login";
import HomeCasino from "../pages/casino/HomeCasino";
import BaccaratRoomList from "../pages/casino/LobbyCasino";
import LobbyRoom from "../pages/casino/LobbyRoom";
import CandleChart from "../pages/casino/chart/CandleChart";
import RecipeList from "../pages/cong-thuc/RecipeList";
import FormulaDetail from "../pages/cong-thuc/FormulaDetail";
import RecipeHome from "pages/cong-thuc/RecipeHome";

const Approuter = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/*"
        element={
          <PrivateRoute>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/casino" element={<HomeCasino />} />
              <Route path="/casino/:id" element={<BaccaratRoomList />} />
              <Route path="/casino/room/:id" element={<LobbyRoom />} />
              <Route path="/cong-thuc" element={<RecipeHome />} />
              <Route path="/cong-thuc-baccarat" element={<RecipeList />} />
              <Route path="/cong-thuc/:id" element={<FormulaDetail />} />
              <Route path="/chart" element={<CandleChart />} />
              <Route path="/admin" element={<HomeAdmin />} />
            </Routes>
          </PrivateRoute>
        }
      />
    </Routes>
  );
};

export default Approuter;
